import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Observable, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { StorageService } from '../services/storage/storage.service';
import { inject } from '@angular/core';

function handleRefreshToken(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  storage: StorageService,
  auth: AuthService
): Observable<HttpEvent<unknown>> {
  let receivedRefreshToken: string | null = null;

  return auth.refreshToken().pipe(
    switchMap((data: any) => {
      storage.setDataLogin(data);
      receivedRefreshToken = data?.refreshToken ?? null;
      // Reintentamos la MISMA request sin modificar headers.
      // El interceptor que agrega el token debe estar DESPUÉS en la cadena.
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${data?.token}`
        }
      });
      return next(clonedReq);
    }),
    catchError((error) => {
      const savedRefresh = storage.getRefreshToken();
      if (savedRefresh && savedRefresh === receivedRefreshToken) {
        // Último intento “as-is”
        return next(req);
      } else {
        storage.logoutWithoutService();
        return throwError(() => error);
      }
    })
  );
}

function handleAuthError(
  err: any,
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  storage: StorageService,
  auth: AuthService
): Observable<HttpEvent<unknown>> {
  if (err instanceof HttpErrorResponse) {
    // Evitar loop si el 401 viene del endpoint de refresh
    if (err.status === 401) {
      if (req.url.includes('auth/refreshtoken')) {
        storage.logoutWithoutService();
        return throwError(() => err);
      }
      return handleRefreshToken(req, next, storage, auth);
    }
  }
  return throwError(() => err);
}

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  
  const storage = inject(StorageService);
  const auth = inject(AuthService);

  // Endpoints a excluir del manejo 
  const isExcluded =
    (req.url.includes('/auth') ||
     req.url.includes('ipify'));

  if (isExcluded) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err) => handleAuthError(err, req, next, storage, auth))
  );
};
